import React, {useEffect, useState} from 'react'
import {connect, useDispatch} from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ReactTooltip from 'react-tooltip'
import colors from '../../../configuration/colors'
import {hideModal, showModal} from '../../../actions/modal'
import Modal from '../../mini/Modal'
import Button from '../../mini/Buttons/Button'
import CancelButton from '../../mini/Buttons/CancelButton'
import H2 from '../../typography/headers/H2'
import H3 from '../../typography/headers/H3'
import MarginRight15 from '../../typography/margins/MarginRight15'
import RadioInputComponent from './InputComponents/RadioInputComponent'
import { mergeJourneyData } from '../../../utils/mycourses'
import withApiData from '../../HOC/withApiData'
import {useQuery} from 'react-query'
import { fetchCloneableJourneys } from '../../mycourses/API'
import JourneySelector from './InputComponents/JourneySelector/JourneySelector'

const ModalContainer = styled.div`
  width: 660px;
  margin: 100px auto;
  border-radius: 10px;
  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.08);
  background-color: ${colors.smoke};
`

const HeaderContainer = styled.div`
  height: 80px;
  width: auto;
  border-radius: 10px 10px 0 0;
  background-color: ${colors.white};
  border-bottom: 1px solid ${colors.rock};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
`
const FooterContainer = styled.div`
  height: 80px;
  width: auto;
  border-radius: 0 0 10px 10px;
  background-color: ${colors.white};
  border-top: 1px solid ${colors.rock};
  display: flex;
  justify-content: end;
  align-items: center;
  padding: 0 30px;
`

const MainContainer = styled.div`
  padding: 30px 30px 10px;
`

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

const StarterJourneyModal = ({apiData, academicTerm, academicYears, selectedAcademicYearId, activityCourse, handleDisplayJourneysListOnCreation, gradeLevels, orgFlags}) => {
  const dispatch = useDispatch()
  const [selectedJourney, setSelectedJourney] = useState(null)
  const [selectedNewOrExisting, setSelectedNewOrExisting] = useState('new')
  const [mergedData, setMergedData] = useState(null)

  const { isLoading: isLoadingCloneableJourneys, data: cloneableJourneys } = useQuery(
    ['cloneable-journeys-' + selectedAcademicYearId],
    () => fetchCloneableJourneys(apiData.orgId, apiData.token, activityCourse.id),
    {
      enabled: !!selectedAcademicYearId && !!apiData.orgId && !!apiData.token && !!activityCourse.id,
      cacheTime: 0
    }
  )

  useEffect(() => {
    if (!isLoadingCloneableJourneys && !cloneableJourneys) {
      handleNext()
    }
    if (cloneableJourneys && cloneableJourneys.length > 0) {
      setMergedData(mergeJourneyData(academicYears, cloneableJourneys, gradeLevels))
    }
  }, [cloneableJourneys, academicYears, gradeLevels, isLoadingCloneableJourneys])

  useEffect(() => {

  }, [])

  const handleCloseModal = () => {
    dispatch(hideModal())
  }

  const handleSelectedNewOrExisting = (value) => {
    setSelectedNewOrExisting(value)
  }

  const handleSelectedJourney = (journey) => {
    setSelectedJourney(journey)
  }

  const handleNext = () => {
    dispatch(hideModal())
    dispatch(
      showModal('CREATE_JOURNEY_MODAL', {
        activityCourseId: activityCourse.id,
        selectedAcademicYearId,
        handleDisplayJourneysListOnCreation,
        selectedJourney,
        color: activityCourse.color
      })
    )
  }

  const couldSaveData = selectedNewOrExisting === 'new' || (selectedNewOrExisting === 'existing' && selectedJourney !== null)
  return (
    <Modal
      width={1400}
      percentHeight={100}
      background={'rgba(36,54,70,0.48)'}
      opacity={'.9'}
      allowInnerScroll
      allowCloseOnExternalClick={false}
    >
      {cloneableJourneys && <ModalContainer>
        <HeaderContainer>
          <H2 blue>+ Add Journey</H2>
          <FlexContainer>
            <H3 light blue>
              {academicTerm}
            </H3>
          </FlexContainer>
        </HeaderContainer>
        <MainContainer>
          <RadioInputComponent onChange={handleSelectedNewOrExisting} disableCloning={!mergedData || mergedData.length < 1} journey={true} orgFlags={orgFlags}/>
          {/* TODO: is loading ? */}
          {selectedNewOrExisting === 'existing' && !isLoadingCloneableJourneys &&
            <JourneySelector
              journeys={mergedData}
              onSelectJourney={handleSelectedJourney}
              initialSelectedJourney={selectedJourney}
            />
          }
        </MainContainer>
        <FooterContainer>
          <MarginRight15>
            <CancelButton handleClick={handleCloseModal} title="Cancel" width="104px"/>
          </MarginRight15>
          <div
            data-for="createCourseJourneyTooltip"
            data-tip="Please select an existing journey."
          >
            <Button
              width="104px"
              title="Next"
              handleClick={handleNext}
              buttonColor={colors.oeYellow}
              borderColor={colors.oeYellow}
              hoverBackground={colors.charcoal4}
              hoverColor={colors.white}
              couldSaveData={couldSaveData}
              shouldShowTooltipAndDisableButton={true}
            />
            {selectedNewOrExisting === 'existing' && !selectedJourney && (
              <ReactTooltip
                id="createCourseJourneyTooltip"
                place="bottom"
                effect="solid"
                className="activityCourseTooltip"
              />
            )}
          </div>
        </FooterContainer>
      </ModalContainer>}
      {!cloneableJourneys && ''}
    </Modal>
  )
}

StarterJourneyModal.propTypes = {
  apiData: PropTypes.object.isRequired,
  activityCourse: PropTypes.object.isRequired,
  selectedAcademicYearId: PropTypes.number.isRequired,
  handleDisplayJourneysListOnJourneyCreation: PropTypes.func.isRequired,
}

export const mapStateToProps = (state) => ({
  user: state.user,
  organization: state.organization,
  academicTerm: state.mycourses.selectedAcademicYearGlobally.name,
})

export default connect(mapStateToProps)(withApiData(StarterJourneyModal))



// WEBPACK FOOTER //
// ./src/components/modal/CreateOrEditCourseModal/StarterJourneyModal.js